import { Popover, PopoverContent, PopoverTrigger } from './Popover';
import { Calendar, CalendarProps } from './Calendar';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons/faCalendarRange';
import { DateTime } from 'luxon';
import { FaIcon } from '../FaIcon';
import { toLocaleDate } from '../../utils/date';
import { cn } from '../../utils';
import { getLocaleFromString } from './getLocaleFromString';

type DateRange = {
  start?: string | null;
  end?: string | null;
};

export const DatePicker = ({
  selectedDate,
  triggerClassName,
  placeholder,
  onSelect,
  allowedRange,
  locale: localeString,
  container,
  calendarProps,
}: {
  selectedDate?: Date,
  triggerClassName?: string;
  placeholder: string;
  onSelect: (date: Date) => void;
  locale?: string;
  allowedRange?: DateRange;
  container: HTMLElement;
  calendarProps?: Partial<CalendarProps>;
}) => {
  const locale = getLocaleFromString(localeString);

  const disabledDates = allowedRange && {
    before: new Date(allowedRange.start as string),
    after: new Date(allowedRange.end as string),
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className={cn(
            'l-tab l-tab-md l-tab-tertiary w-full justify-start text-left text-body-md text-neutral-500',
            triggerClassName
          )}
        >
          <FaIcon icon={faCalendarRange} className={!selectedDate ? "text-neutral-500" : ""}/>
          {selectedDate ? (
            toLocaleDate(selectedDate.toISOString(), DateTime.DATE_FULL)
          ) : (
            <span className="text-neutral-500">{placeholder}</span>
          )}
          <FaIcon icon={faChevronDown} className="ms-auto" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto bg-neutral-0 p-0" container={container}>
        <Calendar
          {...calendarProps}
          mode="single"
          selected={selectedDate}
          locale={locale}
          {...(disabledDates ? { disabled: disabledDates } : {})}
          onSelect={(date) => {
            if (date) {
              onSelect(date);
            }
          }}
          className="rounded-md border"
        />
      </PopoverContent>
    </Popover>
  );
};
